export default {
    firebaseConfig: {
        apiKey: "AIzaSyAIGLIUnm_pE6s2CDjuyvrCNvnNKqa_rLo",
        authDomain: "yourflix-interaction.firebaseapp.com",
        databaseURL: "https://yourflix-interaction.firebaseio.com",
        projectId: "yourflix-interaction",
        storageBucket: "yourflix-interaction.appspot.com",
        messagingSenderId: "869178051901",
        appId: "1:869178051901:web:1ecfcddd56ee2762050954",
        measurementId: "G-K5GV1CSXMH"
    },
    corsURL: 'https://yacdn.org/proxy/',
    //corsURL: 'https://cors-anywhere.herokuapp.com/',
    omdbBaseURL: 'http://www.omdbapi.com',
    omdbKey: 'b0d31d7c',
}